import { forwardRef, InputHTMLAttributes } from 'react';

import { Input } from '@hh.ru/magritte-ui-input/Input';
import { UncontrolledInputProps } from '@hh.ru/magritte-ui-input/types';
import { useUncontrolledInput } from '@hh.ru/magritte-ui-input/useUncontrolledInput';

export const UncontrolledInput = forwardRef<
    HTMLInputElement,
    UncontrolledInputProps & Omit<InputHTMLAttributes<HTMLInputElement>, keyof UncontrolledInputProps>
>(({ value, onChange, ...restProps }, ref) => {
    const [currentValue, changeHandler] = useUncontrolledInput(value, onChange);
    return <Input {...restProps} value={currentValue} onChange={changeHandler} ref={ref} />;
});

UncontrolledInput.displayName = 'UncontrolledInput';
